import type { ActiveCartItem } from '../types';

type CartSource = ActiveCartItem['sources'][number];

export function consolidateManualSources(
    sources: readonly CartSource[],
    manualQuantity: number,
    fallbackOriginName = 'Manual Adjustment',
): CartSource[] {
    const nonManual = sources.filter((source) => source.originType !== 'manual');
    const existingManual = sources.find((source) => source.originType === 'manual');
    const next: CartSource[] = [...nonManual];

    if (manualQuantity > 0) {
        next.push({
            id: existingManual?.id ?? `manual-${Date.now()}`,
            originName: existingManual?.originName ?? fallbackOriginName,
            quantity: parseFloat(manualQuantity.toFixed(2)),
            originType: 'manual',
        });
    }

    return next;
}

export function addManualQuantity(
    sources: readonly CartSource[],
    addQty: number,
    fallbackOriginName = 'Manual',
): CartSource[] {
    const manualTotal = sources
        .filter((source) => source.originType === 'manual')
        .reduce((sum, source) => sum + source.quantity, 0);

    return consolidateManualSources(sources, manualTotal + addQty, fallbackOriginName);
}

export function setTotalQuantity(sources: readonly CartSource[], newTotal: number): CartSource[] {
    const fixedSum = sources
        .filter((source) => source.originType !== 'manual')
        .reduce((sum, source) => sum + source.quantity, 0);

    const manualQuantity = parseFloat((newTotal - fixedSum).toFixed(2));
    return consolidateManualSources(sources, Math.max(0, manualQuantity));
}
